import React, { useState, useEffect } from "react";
import { Loader, Dropdown, Icon } from "semantic-ui-react";
import { toast } from "react-toastify";
import moment from "moment";
import { getTablePlace } from "../../utils/table";
import {
  HeaderPage,
  PrintHeader, PrintTable,
  TablePayments,
  TablePaymentsPrintColumns,
  VoidPaymentModal,
} from "../../components/Admin";
import { usePayment, usePrintOrientation, useAuth } from "../../hooks";
import { getBusinessToday, getBusinessDaysAgo } from "../../utils/date";

const SORT_OPTIONS = [
  { key: "date", value: "date", text: "Por Fecha" },
  { key: "table", value: "table", text: "Por Mesa" },
];

const VIEW_OPTIONS = [
  { key: "summary", value: "summary", text: "Resumido" },
  { key: "detailed", value: "detailed", text: "Detallado" },
];


export function PaymentsHistory() {
  const [dateFrom, setDateFrom] = useState(() => getBusinessDaysAgo(30));
  const [dateTo, setDateTo] = useState(getBusinessToday);
  const [sortBy, setSortBy] = useState("date");
  const [viewMode, setViewMode] = useState("summary");
  const { loading, payments, getPayments, voidPayment } = usePayment();
  const { auth } = useAuth();
  const [voidTarget, setVoidTarget] = useState(null);
  // Anular ventas: solo Admin/Súper Usuario (el backend también lo exige).
  const canVoid = !!auth?.me?.is_staff;
  usePrintOrientation("portrait");

  useEffect(() => {
    if (dateFrom && dateTo) getPayments(sortBy, dateFrom, dateTo);
  }, [sortBy, dateFrom, dateTo]);

  const onConfirmVoid = async (payment, reason) => {
    await voidPayment(payment.id, reason);
    setVoidTarget(null);
    toast.success(`Venta de ${getTablePlace(payment)} anulada`);
    getPayments(sortBy, dateFrom, dateTo);
  };

  const sortLabel = SORT_OPTIONS.find((option) => option.value === sortBy)?.text;
  const dateRangeLabel = `Del ${moment(dateFrom).format("DD/MM/YYYY")} al ${moment(
    dateTo
  ).format("DD/MM/YYYY")} — Ordenado ${sortLabel}`;

  return (
    <>
      <div className="screen-only">
        <HeaderPage
          title="Historial de pagos"
          btnTitle={
            <>
              <Icon name="print" /> Imprimir
            </>
          }
          btnClick={() => window.print()}
        />
      </div>

      <div
        className="screen-only"
        style={{ display: "flex", gap: "15px", margin: "10px 0 20px" }}
      >
        <div>
          <label style={{ display: "block", marginBottom: 4 }}>Desde</label>
          <input
            type="date"
            value={dateFrom}
            max={dateTo}
            onChange={(e) => setDateFrom(e.target.value)}
          />
        </div>
        <div>
          <label style={{ display: "block", marginBottom: 4 }}>Hasta</label>
          <input
            type="date"
            value={dateTo}
            min={dateFrom}
            onChange={(e) => setDateTo(e.target.value)}
          />
        </div>
        <div>
          <label style={{ display: "block", marginBottom: 4 }}>Ordenar por</label>
          <Dropdown
            selection
            options={SORT_OPTIONS}
            value={sortBy}
            onChange={(_, data) => setSortBy(data.value)}
          />
        </div>
        <div>
          <label style={{ display: "block", marginBottom: 4 }}>Tipo de reporte</label>
          <Dropdown
            selection
            options={VIEW_OPTIONS}
            value={viewMode}
            onChange={(_, data) => setViewMode(data.value)}
          />
        </div>
      </div>

      <PrintTable>
        <PrintHeader title="Historial de Pagos" subtitle={dateRangeLabel}>
          <TablePaymentsPrintColumns />
        </PrintHeader>

        {loading ? (
          <Loader active inline="centered">
            Cargando...
          </Loader>
        ) : (
          <div className="print-content">
            <TablePayments
              payments={payments}
              detailed={viewMode === "detailed"}
              onVoid={canVoid ? setVoidTarget : null}
            />
          </div>
        )}
      </PrintTable>

      <VoidPaymentModal
        payment={voidTarget}
        onClose={() => setVoidTarget(null)}
        onConfirm={onConfirmVoid}
      />
    </>
  );
}
